import React from 'react';

const FormDarkContainer = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <div className="dark">
      <div
        ref={ref}
        className="h-full bg-slate-900 text-slate-100 overflow-auto [&_img[src*='storyblok']]:dark:invert [&_img[src*='storyblok']]:dark:brightness-90"
        {...props}
      >
        {children}
      </div>
    </div>
  );
});

FormDarkContainer.displayName = 'FormDarkContainer';

export { FormDarkContainer };
